// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".resource-editor{margin:0 auto}.resource-editor.row .col-12{padding:0}.resource-editor .preview-content{all:initial;all:unset;flex:1;padding:0 40px;border:1px solid var(--color-gray-200);border-radius:4px}.resource-block-editor .card-body>.content>.slate-editor{border:none;outline:none}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
